import FileTextIconOutlined from 'components/icons/FileTextIconOutlined';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const declarationGuide: FeatureGuide = {
    key: 'declaration',
    title: 'Declaration',
    icon: <FileTextIconOutlined />,
    sections: [
        whatItIs('The declaration this arrival relates to, identified by its MRN.'),
        howItHelps('Linking to the lodged declaration lets customs match the arrival to the movement it belongs to.'),
        tips([
            'Enter the MRN exactly as it was issued.',
            'If the declaration is not found, confirm it has been submitted and accepted first.',
        ]),
    ],
};
